import type IParticipation from '../../../models/pa-egna-ben/participation.model';
import { CompetitionApiModel } from './competition.api-model';
import LegReportApiModel from './leg-report.api-model';
import SchoolApiModel from './school.api-model';

export default class ParticipationApiModel {
  public id!: number;
  public name!: string;
  public numberOfStudents!: number;
  public schoolId!: number;
  public school?: SchoolApiModel;
  public competition?: CompetitionApiModel;
  public legReports?: LegReportApiModel[];

  public static mapToBusinessModel(apiModel: ParticipationApiModel): IParticipation {
    return {
      id: apiModel.id,
      name: apiModel.name,
      numberOfStudents: apiModel.numberOfStudents,
      schoolId: apiModel.schoolId,
      school: apiModel.school ? SchoolApiModel.mapToBusinessModel(apiModel.school) : undefined,
      competition: apiModel.competition ? CompetitionApiModel.mapToBusinessModel(apiModel.competition) : undefined,
      legReports: apiModel.legReports?.map((lr) => LegReportApiModel.mapToBusinessModel(lr)) || [],
    };
  }
}
